<div class="grid grid-cols-12 gap-2">
  <!-- Type-ahead variant, opted into per usage with [searchable]. -->
  <mat-form-field
    *ngIf="searchable"
    appearance="outline"
    class="col-span-12"
    floatLabel="always"
  >
    <mat-label>{{ label }} {{ required ? "*" : "" }}</mat-label>
    <input
      matInput
      type="text"
      [placeholder]="searchPlaceholder"
      [disabled]="disabled"
      [(ngModel)]="selectedUser"
      (ngModelChange)="filterUsers($event)"
      [matAutocomplete]="auto"
    />
    <mat-icon matSuffix>search</mat-icon>

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayUser"
      (optionSelected)="selectUserItem($event.option.value.value)"
    >
      <mat-option *ngFor="let user of filteredUsers" [value]="user">
        {{ user.viewValue }}
      </mat-option>
      <mat-option *ngIf="!filteredUsers.length" disabled>
        No matching users
      </mat-option>
    </mat-autocomplete>

    <div
      *ngIf="loading"
      class="absolute right-8 top-1/2 -translate-y-1/2 pointer-events-none"
    >
      <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
    </div>
  </mat-form-field>

  <mat-form-field
    *ngIf="!searchable"
    appearance="outline"
    class="col-span-12"
  >
    <mat-label>{{label}} {{ required ? "*" : "" }}</mat-label>
    <mat-select
      [disabled]="disabled"
      [(ngModel)]="selectedValue"
      (selectionChange)="selectUserItem($event.value)"
    >
      <mat-option
        *ngFor="let department of users"
        [value]="department.value"
      >
        {{ department.viewValue }}
      </mat-option>
    </mat-select>
       <div
        *ngIf="loading"
        class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
      >
        <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
      </div>
  </mat-form-field>

</div>
